class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );

    this.notification.addEventListener('click', this.handleQuantityClick.bind(this));
    this.parseState = {};
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.parseState = parsedState;
    this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach((section) => {
      document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    if (this.header) this.header.reveal();
    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  async fetchCartData() {
    const response = await fetch('/cart.json');
    if (!response.ok) {
      throw new Error('Network response was not ok ' + response.statusText);
    }
    const data = await response.json();
    return data;
  }

  handleQuantityClick(evt) {
    const target = evt.target;
    if (target.matches('.plus-icon') || target.matches('.icon-minus')) {
      const quantityInput = target.closest('.quantity');
      const input = quantityInput.querySelector('.quantity__input');
      // const change = target.matches('.plus-icon') ? 1 : -1;

      let newQuantity = parseInt(input.value);
      newQuantity = newQuantity < 1 ? 1 : newQuantity; // Prevent quantity from going below 1
      input.value = newQuantity;
      this.updateCartQuantity(input.id, newQuantity, target);
      const qty_box = document.querySelector('.quantity-container .quantity');
      qty_box.style.pointerEvents = 'none';
    }

    if (target.matches('.cart-remove-button-notification') || target.matches('.icon-remove')) {
      const buttonElement = document.querySelector('.cart-remove-button-notification');

      // Get the value of the data-variant-id attribute
      const variantId = buttonElement.getAttribute('data-variant-id');
      this.removeCartItem(variantId);
    }
  }

  async removeCartItem(variantId) {
    const updates = {};
    updates[variantId] = 0;

    try {
      const response = await fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ updates })
      });

      if (!response.ok) {
        throw new Error('Network response was not ok ' + response.statusText);
      }

      const data = await response.json();
      if (data) {
        const cartData = await this.fetchCartData();
        const cart_item_count = cartData.item_count;

        const cartCountSpan = document.querySelector('.cart-count-bubble');
        const cartNotificationButton = document.querySelector('#cart-notification-button');
        cartCountSpan.innerHTML = `<span aria-hidden="true">&nbsp;(${cart_item_count})</span><span class="visually-hidden">&nbsp;${cart_item_count} items</span>`;
        cartNotificationButton.innerHTML = `View cart (${cart_item_count})`;
        this.close();
      }
    } catch (error) {
      console.error('Failed to update cart quantity:', error);
    }
  }

  async updateCartQuantity(variantId, quantity, target) {
    const updates = {};
    const variantItemId = variantId.replace('Quantity-', '')
    updates[variantItemId] = quantity;

    try {
      const response = await fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ updates })
      });

      if (!response.ok) {
        throw new Error('Network response was not ok ' + response.statusText);
      }

      const data = await response.json();
      if (data) {
        const cartData = await this.fetchCartData();
        const item_price = cartData.items.filter(item => item.id == variantItemId)[0].original_line_price;
        const cart_item_count = cartData.item_count;
        const currency = cartData.currency;

        const cartCountSpan = document.querySelector('.cart-count-bubble');
        const cartNotificationButton = document.querySelector('#cart-notification-button');
        cartCountSpan.innerHTML = `<span aria-hidden="true">&nbsp;(${cart_item_count})</span><span class="visually-hidden">&nbsp;${cart_item_count} items</span>`;
        cartNotificationButton.innerHTML = `View cart (${cart_item_count})`;
        document.querySelector('.cart-notification-product__info-subtotal .product-item-price').innerHTML = this.formatPrice(item_price, currency);

        let notificationMsgElement = document.querySelector('.item_notification_msg');
        if (target.matches('.plus-icon')) {
          notificationMsgElement.innerHTML = '1 Item added to bag';
        } else {
          notificationMsgElement.innerHTML = '1 Item removed from bag';
        }

        const qty_box_updated = document.querySelector('.quantity-container .quantity');
        qty_box_updated.style.pointerEvents = 'auto';
      }
    } catch (error) {
      console.error('Failed to update cart quantity:', error);
    }
  }

  formatPrice(price, currency) {
    return new Intl.NumberFormat('en-US', { style: 'currency', currency: currency }).format(price / 100);
  }
}

customElements.define('cart-notification', CartNotification);
